import React from 'react';
import { capitalize } from "../../../../../../Utils";
import { PARAMS_NAME } from "../../../../config";

const Head = ({ onSortChange, params }) => {
    let th = params.map(param => {
        const paramName = PARAMS_NAME[param] ? PARAMS_NAME[param] : capitalize(param);

        return <th onClick={() => onSortChange(param)} key={param}>{paramName}</th>;
    });

    return (
        <thead>
            <tr>{th}</tr>
        </thead>
    )
};

export default Head;



// WEBPACK FOOTER //
// ./src/scenes/Adk5MinFactor/components/Table/components/Head/index.js